import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useRef, useEffect, useCallback } from 'react';
import useCallbackRef from './use-callback-ref.esm.js';
import { runIfFn } from '../utils/function.esm.js';

function useControllableProp(prop, state) {
  var isControlled = prop !== undefined;
  var value = isControlled && typeof prop !== 'undefined' ? prop : state;
  return [isControlled, value];
}
var DEBUG = process.env.NODE_ENV !== 'production' && false;

/**
 * React hook for using controlling component state.
 * @param props
 */
function useControllableState(props) {
  var valueProp = props.value,
    defaultValue = props.defaultValue,
    onChange = props.onChange,
    _props$shouldUpdate = props.shouldUpdate,
    shouldUpdate = _props$shouldUpdate === void 0 ? function (prev, next) {
      return prev !== next;
    } : _props$shouldUpdate;
  var onChangeProp = useCallbackRef(onChange);
  var shouldUpdateProp = useCallbackRef(shouldUpdate);
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    valueState = _useState2[0],
    setValue = _useState2[1];
  var isControlled = valueProp !== undefined;
  var value = isControlled ? valueProp : valueState;
  var valueRef = useRef(value);
  if (DEBUG) {
    // eslint-disable-next-line no-console
    console.log(" ------ useControllableState isControlled ".concat(isControlled, " value: ").concat(value, " -------"));
  }
  useEffect(function () {
    if (isControlled) {
      valueRef.current = value;
    }
  }, [isControlled, value]);
  var updateValue = useCallback(function (next) {
    var nextValue = runIfFn(next, value);
    if (!shouldUpdateProp(value, nextValue)) {
      return;
    }
    if (!isControlled) {
      setValue(nextValue);
    }
    if (DEBUG) {
      // eslint-disable-next-line no-console
      console.log(" ------ useControllableState emitting onChangeProp ".concat(isControlled, " nextValue: ").concat(nextValue, " -------"));
    }
    onChangeProp(nextValue);
    valueRef.current = nextValue;
  }, [isControlled, onChangeProp, value, shouldUpdateProp]);
  return {
    state: [value, updateValue, valueRef],
    isControlled: isControlled
  };
}

export default useControllableState;
export { useControllableProp };
//# sourceMappingURL=use-controllable.esm.js.map
